import React from 'react';
import PropTypes from 'prop-types';

import {
    Image,
    StockImageAttributionContainer,
    StockImageContainer,
    StockImageAttributionLink,
} from './StockSlide.styles';

export default function StockImage({ baseClassName, stockImage, onStockImageSelected, href }) {
    return (
        <StockImageContainer>
            <Image
                className={`${baseClassName}_stock-image`}
                src={stockImage.urls.small}
                alt={stockImage.alt_description}
                onClick={(event) => onStockImageSelected(stockImage)}
            />
            <StockImageAttributionContainer variation="flex-center" className={`${baseClassName}_stock-image-attr`}>
                <StockImageAttributionLink href={href} target="_blank" onClick={(event) => event.stopPropagation()}>
                    {stockImage.user.name}
                </StockImageAttributionLink>
            </StockImageAttributionContainer>
        </StockImageContainer>
    );
}

StockImage.propTypes = {
    baseClassName: PropTypes.string,
    href: PropTypes.string,
    stockImage: PropTypes.object.isRequired,
    onStockImageSelected: PropTypes.func.isRequired,
};

StockImage.defaultProps = {
    baseClassName: '',
    href: '',
};
